import { useMutation } from '@tanstack/react-query';
import {
  updatePlayerAvatar,
  updatePlayerAvatarFrame,
  removePlayerAvatarFrame,
} from '../../services/client/user';

export const useUpdatePlayerAvatar = ({ onSuccess }) => {
  return useMutation({
    mutationFn: async (data: { avatarId: number }) => {
      return await updatePlayerAvatar(data);
    },
    onSuccess,
  });
};

export const useUpdatePlayerFrame = ({ onSuccess }) => {
  return useMutation({
    mutationFn: async (data: { frameId: number }) => {
      return await updatePlayerAvatarFrame(data);
    },
    onSuccess,
  });
};

export const useRemovePlayerFrame = ({ onSuccess }) => {
  return useMutation({
    mutationFn: async () => {
      return await removePlayerAvatarFrame();
    },
    onSuccess,
  });
};
